module.exports = __webpack_public_path__ + "static/media/15_1.88524b3a.png";